/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'paneUserWorkflowId';
const QS_TYPE: QueryStateSchema['type'] = 'pacerPreview';

export const useOpenPacerPreviewPane = (): ((args: { userWorkflowId: string }) => void) => {
  const [userWorkflowIdDeprecated, setUserWorkflowId] = useQueryState(QS_KEY);
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (userWorkflowIdDeprecated) {
      setUserWorkflowId(null);
      setState(backwardsCompatabilityFactory({ id: userWorkflowIdDeprecated, type: QS_TYPE }));
    }
  }, [userWorkflowIdDeprecated]);

  return ({ userWorkflowId }) => {
    setState(prevState => [...(prevState || []), {
      id: userWorkflowId,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};